<template>
  <div style="max-width: 1050px" class="mx-auto">
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title class="grey--text" v-if="!search">
          Produtos
        </v-toolbar-title>

        <v-spacer v-if="!search"></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-5">
          <v-col cols="12" sm="6" md="5">
            <core-table-filter
              light
              prepend-inner-icon="mdi-magnify"
              label="Pesquisar Produto"
              hide-details
              single-line
              class="mr-3"
              outlined
              dense
            />
          </v-col>
          <v-col class="text-right">
            <v-btn @click="handleOpenNewForm()" dark color="red">
              <v-icon left>mdi-plus</v-icon>Cadastrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <core-table
        ref="table"
        :loading="loading"
        :headers="headers"
        class="py-5"
        index-url="/products"
        :items-per-page-options="[5, 15, 50]"
        :items-per-page="15"
        sort-by="nome"
      >
        <template v-slot:item.id="{ item }">
          <a @click="handleOpenEditForm(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.nome="{ item }">
          <a @click="handleOpenEditForm(item)">
            {{ item.nome }} ({{ item.unidade_medida }})
          </a>
        </template>
        <template v-slot:item.modelo="{ item }">
          <span :class="{ 'grey--text': !item.modelo }">{{
            item.modelo || "N/A"
          }}</span>
        </template>
        <template v-slot:item.preco_venda="{ item }">
          <span>{{ formatMoney(item.preco_venda) }}</span>
        </template>
        <template v-slot:item.min_preco_venda="{ item }">
          <span>{{ formatMoney(item.min_preco_venda) }}</span>
        </template>
        <template v-slot:item.preco_custo="{ item }">
          <span
            :class="{
              'warning--text': item.preco_custo >= item.min_preco_venda
            }"
            >{{ formatMoney(item.preco_custo) }}</span
          >
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            @click="handleOpenEditForm(item)"
            :disabled="checkExcluding(item)"
            icon
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click="deleteItem(item)" :loading="checkExcluding(item)" icon>
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </template>
      </core-table>
    </v-card>
    <v-dialog max-width="500" v-model="form" persistent>
      <ProductForm
        @submitted="handleSubmitForm"
        @cancel="handleCloseNewForm()"
        :seed="edit_item"
        @cleared="edit_id = null"
      />
    </v-dialog>
  </div>
</template>

<script>
import { index, destroy } from "@/services/products";
import { format as formatMoney } from "@/utils/money";
import ProductForm from "@/components/forms/ProductForm";
import CoreTable from "@/components/CoreTable";
import CoreTableFilter from "@/components/CoreTableFilter";

export default {
  name: "products",
  components: { ProductForm, CoreTable, CoreTableFilter },
  data: () => ({
    items: [],
    total_items: 0,
    loading: false,
    options: {
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
    filter: "",
    search: false,
    excluding_id: null,
    form: false,
    edit_item: null
  }),
  methods: {
    handleFilter() {
      this.$refs.table.handleFilter(this.filter);
    },
    handleOpenNewForm() {
      this.form = true;
    },
    handleCloseNewForm() {
      this.form = false;
    },
    handleOpenEditForm(item) {
      this.edit_item = { ...item };
      this.form = true;
    },
    handleSubmitForm() {
      this.getItems();
      this.handleCloseNewForm();
    },
    formatMoney(value) {
      return formatMoney(value);
    },
    handleOpenSearch() {
      this.search = true;
    },
    async deleteItem(item) {
      const confirm = window.confirm(
        "Tem certeza que deseja excluir este item?"
      );
      if (!confirm) return;

      this.excluding_id = item.id;
      try {
        await destroy(item.id);
        this.items = this.items.filter(i => item.id !== i.id);
        this.$store.commit("sendMessage", {
          text: "Produto removido"
        });
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao excluir produto",
          color: "red"
        });
      } finally {
        this.excluding_id = null;
      }
    },
    checkExcluding(item) {
      return item.id == this.excluding_id;
    },
    getItems() {
      this.$refs.table.getItems();
    },
    handleClearFilter() {
      this.search = false;

      if (this.filter) {
        this.filter = "";
        this.getItems();
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true
    }
  },
  computed: {
    user: function() {
      return this.$store.getters.getUser;
    },
    headers: function() {
      let headers = [
        { text: "Cód", value: "id" },
        { text: "Nome", value: "nome" },
        { text: "Marca", value: "marca" },
        { text: "Modelo", value: "modelo" },
        { text: "Preço", value: "preco_venda" },
        { text: "Preço Mínimo", value: "min_preco_venda" }
      ];
      headers.push({ text: "Custo", value: "preco_custo" });

      headers.push({ text: "", value: "actions", align: "right", width: 130 });

      return headers;
    }
  }
};
</script>
